<template>
  <div>
    <relation-operation-mode
      v-if="activeStep === 'relation'"
      :draft="draft"
      :preview="preview"
      @update-draft="$emit('update-draft', $event)"
    />
    <product-operation-mode
      v-else-if="activeStep === 'product'"
      :draft="draft"
      :preview="preview"
      @update-draft="$emit('update-draft', $event)"
      @product-selected="$emit('product-selected', $event)"
      @billing-type-changed="$emit('billing-type-changed', $event)"
    />
  </div>
</template>

<script>
import ProductOperationMode from "./ProductOperationMode.vue";
import RelationOperationMode from "./RelationOperationMode.vue";

export default {
  name: "SetupRelationProductOperationMode",
  components: {
    ProductOperationMode,
    RelationOperationMode,
  },
  props: {
    activeStep: {
      type: String,
      required: true,
    },
    draft: {
      type: Object,
      required: true,
    },
    preview: {
      type: Object,
      default: null,
    },
  },
};
</script>
